var map = {
	"./context.json": [
		10396,
		260
	],
	"./default-context.json": [
		99920,
		300
	],
	"./default-en.json": [
		5322,
		324
	],
	"./default-fr.json": [
		33217,
		719
	],
	"./email-en.json": [
		81329,
		671
	],
	"./email-fr.json": [
		58858,
		716
	],
	"./en.json": [
		45398,
		748
	],
	"./fr.json": [
		19909,
		863
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61496;
module.exports = webpackAsyncContext;